import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Timeline sharing routes updated

// Lecture 285
// import Home from './components/Home.vue';
// import Portfolio from './components/portfolio/Portfolio.vue';
// import Stocks from './components/stocks/Stocks.vue';

// import Dashboard from './components/myrundash/dashboard/Dashboard.vue';
// import RaceLog from './components/myrundash/RaceLog.vue';
// import RacePlanner from './components/myrundash/RacePlanner.vue';
// import TrainingPlan from './components/myrundash/TrainingPlan.vue';
import Home from './components/Home.vue'
import Home2 from './components/Home2.vue'
import Login from './components/Login.vue';
import Registration from './components/Registration.vue';
import Logout from "./components/authentication/Logout.vue";
import Dashboard from './components/Dashboard.vue';
import Timeline from './components/Timeline.vue';
import Admin from './components/Admin.vue';
// import UserProfile from './components/UserProfile.vue';
// import BuddyFinder from './components/myrundash/BuddyFinder'

// import CoachDashboard from './components/myrundash/coach/Dashboard.vue';

// import MarathondynamicsHome from './components/myrundash/marathondynamics/Home.vue';
// import MarathondynamicsRegistration from './components/myrundash/marathondynamics/Registration.vue';
// import JustkeeprunningHome from './components/myrundash/teamlandings/JustKeepRunning.vue';

// import PasswordResetRequest from './components/password/PasswordResetRequest.vue';
// import PasswordReset from './components/password/PasswordReset.vue';

// import Map from './components/global/MapTest'

const routes = [
  // { path: '/stockhome', component: Home },
  // { path: '/', component: Home },
  { path: '/', component: Home2 },
  // { path: '/portfolio', component: Portfolio },
  // { path: '/stocks', component: Stocks },

  // { path: '/profile', component: UserProfile },
  // { path: '/dashboard', component: Dashboard },
  // { path: '/racelog', component: RaceLog },
  // { path: '/raceplanner', component: RacePlanner },
  // { path: '/trainingplan', component: TrainingPlan },
  // { path: '/buddyfinder', component: BuddyFinder, name: 'Buddy Finder' },

  { path: '/login', component: Login, name: 'Login' },
  { path: '/register', component: Registration, name: 'Registration' },
  { path: "/logout", component: Logout, name: "Logout" },
  { path: '/dashboard', component: Dashboard, name: 'Dashboard' },
  { path: '/timeline', component: Timeline, name: 'timeline', props: (route) => ({ userID: route.query.userID }) },
  { path: '/shared/:token/:accessType', component: Timeline, name: 'shared-timeline', props: true },
  { path: '/admin', component: Admin, name: "Admin" },

  // { path: '/coachdashboard', component: CoachDashboard },

  // { path: '/marathondynamics', component: MarathondynamicsHome, name: 'MDI Home' },
  // { path: '/marathondynamics/register', component: MarathondynamicsRegistration, name: 'MDI Registration' },
  // { path: '/justkeeprunning', component: JustkeeprunningHome, name: 'JKR Home' },

  // { path: '/reset-password', component: PasswordResetRequest, name: 'Password Reset Request' },
  // { path: '/reset-password/:token', component: PasswordReset, name: 'Password Reset' },

  // { path: '/map', component: Map },
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router.js